import { render } from "./notification-history.vue?vue&type=template&id=7b7736c5&ts=true"
import script from "./notification-history.vue?vue&type=script&lang=ts"
export * from "./notification-history.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__